import { GpsReport } from './gps-report.type';

export enum CompleteRouteResultEnum {
  Unknown = 0,
  Successful = 1,
  RidesRemainIncomplete = 2
}

export type CompleteRoute = {
  sessionId: string;
  gpsReport: GpsReport;
  driverSignature: string;
}
